<app-dashboard-template>
    <p-confirmDialog />
    <app-pro-feature-modal
        [(visible)]="showVcuLimitModal"
        featureName="Adicionar mais VCUs"
        [currentPlanId]="currentPlanId"
        [billingType]="billingType"
        (planUpgraded)="onPlanUpgraded()" />
    <div class="header-tabs">
        <div class="tab active">
            {{ 'dashboard.myVcus' | transloco }}
        </div>
    </div>

    <div class="vcu-section">
        <app-vcu-list-pair></app-vcu-list-pair>
    </div>

    <div class="vcu-section">
        <div class="offline-section-header">
            <h2>{{ 'vcu.offlineSection' | transloco }}</h2>
            <p-button
                icon="pi pi-plus"
                severity="danger"
                [raised]="true"
                label="{{'vcu.addButton' | transloco }}"
                (click)="createVcu()" />
        </div>
        <div class="overlay" *ngIf="loadingVcu">
          <p-progressSpinner styleClass="large-spinner"></p-progressSpinner>
        </div>
        <div class="carousel-container">
            <div class="carousel-wrapper">
                <div class="carousel-inner">
                    <div class="carousel-item" *ngFor="let vcu of vcus; let i = index">
                        <app-card-vcu [vcu]="vcu" [showUnlink]="false"></app-card-vcu>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-register-vcu [showDialog]="showVcuDialog" (closeDialog)="updateVcuDialog()" [vcu]="vcuEdit" [editMode]="editMode"></app-register-vcu>
</app-dashboard-template>
